import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Button, Popover, Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { CopyOutlined } from "@ant-design/icons";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const KeyGenarations = () => {
  const [KeyGenarations, setKeyGenarations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClientType, setSelectedClientType] = useState(null);
  const [selectedKeygenerationType, setSelectedKeygenerationType] =
    useState(null);
  const [keyGenerationData, setKeyGenerationData] = useState();
  console.log(selectedKeygenerationType);
  const [keyGenerationForm, setKeyGenerationForm] = useState({
    SuperId: "",
    MACId: "",
    POSTerminalId: "",
    GeneratedKey: "",
    CreatedBy: "",
    LocationId: "",
    KeyDate: "",
    GracePeriod: "",
  });

  const resetKeyGenerationForm = () => {
    setKeyGenerationForm({
      SuperId: "",
      MACId: "",
      POSTerminalId: "",
      GeneratedKey: "",
      CreatedBy: "",
      LocationId: "",
      KeyDate: "",
      GracePeriod: "",
    });

    setSelectedKeygenerationType(null);
  };

  const columns = [
    {
      title: "Super ID",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (_, record) => {
        const truncated =
          record?.OrgName?.length > 45
            ? record?.OrgName?.substring(0, 45) + "..."
            : record?.OrgName;
        return <span title={record?.OrgName}>{truncated}</span>;
      },
      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },
   

    {
      title: "Serial No",
      dataIndex: "MACId",
      render: (text) => {
        if (!text) return null;

        const short = text.length > 25 ? text.substring(0, 25) + "..." : text;

        return (
          <Popover
            content={
              <div style={{ maxWidth: 220, wordBreak: "break-word" }}>
                {text}
              </div>
            }
            trigger={["hover", "click"]}
            placement="topLeft"
          >
            <span style={{ cursor: "pointer" }}>{short}</span>
          </Popover>
        );
      },
    },
    {
      title: "MC Id",
      dataIndex: "POSTerminalId",
    },
    {
      title: "License Key",
      dataIndex: "LicenseKey",
      align: "center",
      render: (text) => {
        if (!text) return null;

        const content = (
          <div
            style={{
              maxWidth: 250,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 8,
            }}
          >
            <div style={{ wordBreak: "break-word" }}>{text}</div>

            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText(text)}
            >
              Copy
            </Button>
          </div>
        );

        return (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Popover
              content={content}
              trigger={["hover", "click"]}
              placement="top"
            >
              <span style={{ cursor: "pointer" }}>
                <i className="fa-solid fa-key"></i>
              </span>
            </Popover>
          </div>
        );
      },
    },
    {
      title: "Next Renewal",
      dataIndex: "LicenseDate",
      sorter: (a, b) =>
        dayjs(a?.LicenseDate, "DD-MM-YYYY").valueOf() -
        dayjs(b?.LicenseDate, "DD-MM-YYYY").valueOf(),
    },
  ];

  const getallorgkeygeneration = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getallorgkeygeneration`,
      );
      const data = response.data?.ResultData || [];
      setKeyGenarations(data);
    } catch (error) {
      console.error("Error fetching inactive organizations:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle Edit Click - Populate Modal (optional enhancement)
  const handleEdit = (record) => {
    // You can set state here to prefill modal if needed
    console.log("Editing getallorgkeygeneration:", record);
  };

  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [addLoading, setAddLoading] = useState(false);
  console.log(addLoading);

  const fetchProductType = async () => {
    try {
      //  setLoadingProducts(true);
      const res = await fetch(`${API_BASE_URL}/api/getProductType`);

      if (!res.ok) throw new Error("Failed to fetch productOptions");
      const data = await res.json();

      if (data.Status === true) {
        setProductTypeOptions(
          data.ResultData.map((item) => ({
            label: item.ProducutName,
            value: String(item.Id),
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching productOptions:", error);
    } finally {
      //  setLoadingProducts(false);
    }
  };

  const addKeygeneration = async () => {

    setAddLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/addkeygenaration`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(keyGenerationForm),
      });

      const result = await response.json();

      if (result.ResultData[0].Status === "1") {
        Swal.fire({
          title: "Keygenaration Added Successfully",
          text: "The new keygeneration has been added.",
          icon: "success",
          confirmButtonText: "OK",
        });
        resetKeyGenerationForm();
        getallorgkeygeneration();
      } else {
        // Swal.fire({
        //   title: "Failed to Add Keygenaration",
        //   text: "Something went wrong while adding the Keygenaration.",
        //   icon: "error",
        //   confirmButtonText: "OK",
        // });
      }
    } catch (error) {
      console.error("Error adding Keygenaration:", error);
    } finally {
      setAddLoading(false);
    }
  };

  const fetchClintes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}/api/getorganizationtype`);

      if (!res.ok) throw new Error("Failed to fetch ClientTypes");
      const data = await res.json();
      console.log(data.Status, "cbsjkahchjksad");

      if (data.Status === true) {
        setClients(
          data.ResultData.map((item) => ({
            label: item.OrgName, // FIXED
            value: String(item.SuperId),
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };
  const fetchKeyGeneration = async () => {
    try {
      console.log(selectedClientType, "selectedClientType");
      const res = await fetch(
        `${API_BASE_URL}/api/getkeygenarationsuperid?SuperId=${selectedClientType.value}`,
      );

      if (!res.ok) throw new Error("Failed to fetch ClientTypes");
      const data = await res.json();
      console.log(data.ResultData[0], "cbsjkahchjksad");

      if (data.Status === true) {
        setKeyGenerationData(data.ResultData[0]);
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  const handleClientSelect = (option) => {
    setSelectedClientType(option);
  };

  useEffect(() => {
    fetchKeyGeneration();
  }, [selectedClientType]);

  useEffect(() => {
    getallorgkeygeneration();
    fetchProductType();
    addKeygeneration();
    fetchClintes();
  }, []);


  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {/* {addLoading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(255,255,255,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <Spin size="large" />
            </div>
          )} */}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Key Genaration</h4>
                <h6>Manage your Key Genarations</h6>
              </div>
            </div>
            <ul className="table-top-head">
            <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
                title="Add Key"
              >
                <i className="ti ti-circle-plus" style={{ fontSize: "18px" }}></i>
              
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Keys List</h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={KeyGenarations}
                      
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* /Page Wrapper */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">New Key Generation</h4>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Super Id *</label>
                    <Select
                      className="w-100"
                      options={clients}
                      placeholder="Choose"
                      value={selectedClientType}
                      onChange={handleClientSelect}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">License Type *</label>
                    <Select
                      classNamePrefix="react-select"
                      options={[
                        { value: "Organization", label: "Organization" },
                        { value: "Individual", label: "Individual" },
                      ]}
                      placeholder="License Type"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Product Type *</label>
                    <Select
                      className="w-100"
                      options={productTypeOptions}
                      placeholder="Choose"
                      value={keyGenerationData?.ProductType}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Store ID / Branch ID *</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">
                      Terminal ID / Machine ID *
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">MAC / Serial No *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter MAC / Serial No"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Next Renewal *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <Link
                  to="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Edit Plan */}
      <div className="modal fade" id="edit_organization">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Organization</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">MAC / Serial No</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter MAC / Serial No"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Terminal ID / Machine ID
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Store ID / Branch ID</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Next Renewal Date</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleEdit}
                  >
                    Update Client
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Plan */}
    </>
  );
};

export default KeyGenarations;
